import { Stack } from "@mui/material";
import { SphereTooltipIcon } from "@components/common/sphere-tooltip-icon";
import { Text, InfoIcon } from "@flat-ui";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { LIMIT_LABEL } from "@src/constants/subscription-constants";
import { limitTooltips } from "@pages/settings/subscription-settings/usage-metrics/limit-tooltips";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** The type of the limit to display */
  type: FaroCoreApiTypes.LimitQuotaIdentifier;
}

/** Displays a label for a limit type with an optional tooltip */
export function LimitLabel({ type }: Props): JSX.Element {
  const tooltipLabel = limitTooltips[type];

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Text variant="bodyM" sx={{ lineHeight: "1.5rem" }}>
        {capitalizeFirstLetter(LIMIT_LABEL[type])}
      </Text>
      {tooltipLabel && (
        <SphereTooltipIcon icon={InfoIcon} text={tooltipLabel} />
      )}
    </Stack>
  );
}
